module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-LightItalic.f0177f3f.ttf";